import { render, staticRenderFns } from "./Lgx479736463433400320.vue?vue&type=template&id=c9de36e4&scoped=true&"
import script from "./Lgx479736463433400320.vue?vue&type=script&lang=js&"
export * from "./Lgx479736463433400320.vue?vue&type=script&lang=js&"
import style0 from "./Lgx479736463433400320.vue?vue&type=style&index=0&id=c9de36e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9de36e4",
  null
  
)

export default component.exports